// JavaScript Document

(function ($) {

	//Smoothly return anywhere in a page
	smoothScroll = function (obj, speed, adj_height) {
		var y = $(obj).offset().top;
		$('html, body').delay(20).animate({ scrollTop: y - adj_height }, speed);
	}

	//----------------------------------------- 

	jQuery(document).ready(function ($) {
		/* My account Dropdown menu ------ START*/
		$(".jk_dropdown_toggle .trigger").click(function (event) {
          event.preventDefault();
          //
          $(".jk_dropdown_toggle .prof-dropdown-menu").hide();
          $(this).next('.prof-dropdown-menu').stop().delay(150).slideToggle("fast");
          $(".jk_dropdown_toggle").removeClass('open');
          $(this).parent().addClass('open');       
		});
      
		$(document).on("click", function (event) {                 
			var $trigger = $(".jk_dropdown_toggle");
			if ($trigger !== event.target && !$trigger.has(event.target).length) {
				$(".jk_dropdown_toggle .prof-dropdown-menu").fadeOut(200);
				$(".jk_dropdown_toggle").removeClass('open');
			}
		});
		/* My account Dropdown menu ------ END*/

	});
})(jQuery);






